module.exports = __webpack_public_path__ + "static/media/mind.f8b7507a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mind.png
// module id = 533
// module chunks = 0